import React from "react"
import ReactDOM from "react-dom"
import AirportList from "./airport-list"

import "./_destination-page.scss"
export default class AirportListModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.airports = elem.dataset.airports && JSON.parse(elem.dataset.airports)
    self.textKeys = elem.dataset.textKeys && JSON.parse(elem.dataset.textKeys)
    this.init()
    return self
  }
  init() {
    const self = this
    if (self.airports && self.airports.length > 0) {
      ReactDOM.render(<AirportList airports={self.airports} textKeys={self.textKeys} />, self.elem)
    }
  }
}
